// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".d2ef36033d7bf978d86b883f3edb803b34edf9d0.chunk.bundle.js";
};